import { render, staticRenderFns } from "./project.vue?vue&type=template&id=3df8e596"
import script from "./project.js?vue&type=script&lang=js&external"
export * from "./project.js?vue&type=script&lang=js&external"
import style0 from "./project.vue?vue&type=style&index=0&id=3df8e596&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports